import { render, staticRenderFns } from "./ticket-event-item.vue?vue&type=template&id=7a0d9fcf&scoped=true"
import script from "./ticket-event-item.vue?vue&type=script&lang=js"
export * from "./ticket-event-item.vue?vue&type=script&lang=js"
import style0 from "./ticket-event-item.vue?vue&type=style&index=0&id=7a0d9fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d9fcf",
  null
  
)

export default component.exports